import SkinTheme from './Index.vue'

SkinTheme.install = function(Vue) {
  Vue.component(SkinTheme.name, SkinTheme)
}

export default SkinTheme
